<template>
    <div class="werwer">
        <van-field
            v-model="iptAnswer"
            rows="5"
            autosize
            :readonly="justWatch"
            type="textarea"
            show-word-limit
            border
            maxlength="2000"
            placeholder="请输入答案"
            @blur="QABlur()"
        />
        <Uploader
            v-if="question.uploadFlag == 1"
            :justWatch="justWatch"
            @enclosureData="enclosureData"
            :uriList="uriList"
        />
    </div>
</template>

<script>
import Uploader from './../components/Uploader'
export default {
    components: { Uploader },
    props: {
        justWatch: {
            type: Boolean,
            default: false
        },
        combinationFlag: {
            type: Boolean,
            default: false
        },
        currentQuestion: {
            type: Object,
            default() {
                return {}
            }
        },
        subQuestion: {
            type: Object,
            default() {
                return {}
            }
        },
        moreChoose: {
            type: Object,
            default() {
                return {}
            }
        },
        currentParams: {
            type: Object,
            default() {
                return {}
            }
        },
        questionsList: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            iptAnswer: '',
            question: {}, // 当前题目信息
            uriList: [],
            params: {}
        }
    },
    created() {
        // 不能换成mounted
        if (this.combinationFlag) {
            this.iptAnswer = this.subQuestion.userAnswer
            this.uriList = this.subQuestion.uriList || []
            this.question = this.subQuestion
        } else {
            this.iptAnswer = this.currentQuestion.userAnswer
            this.uriList = this.currentQuestion.uriList || []
            this.question = this.currentQuestion
        }
    },

    methods: {
        // 附件信息
        enclosureData(uriList) {
            console.log(uriList, 'enclosureData')
            this.uriList = uriList
            this.QABlur()
        },
        // 问答失去焦点=>数据处理
        QABlur() {
            const questionId = this.combinationFlag ? this.subQuestion.parentId : this.currentQuestion.questionId
            let params = {
                answer: this.iptAnswer,
                mark: this.currentQuestion.mark === undefined ? 0 : this.currentQuestion.mark,
                questionId,
                questionType: this.currentQuestion.type,
                subQuestionId: this.subQuestion.id, // 当前选项所在题id
                subQuestionType: this.subQuestion.type ?? null,
                uri: ''
            }
            if (this.uriList.length > 0) params.uri = JSON.stringify(this.uriList)
            if (this.combinationFlag) {
                if (params.answer) {
                    this.subQuestion.responds = 1
                } else this.subQuestion.responds = 0
                this.subQuestion.userAnswer = this.iptAnswer
                this.subQuestion.uriList = this.uriList
            } else {
                if (params.answer) {
                    this.currentQuestion.responds = 1
                } else this.currentQuestion.responds = 0
                this.currentQuestion.userAnswer = this.iptAnswer
                this.currentQuestion.uriList = this.uriList
            }
            this.$emit('update:moreChoose', { ...params })
            this.$emit('update:currentParams', params)
            console.log(params, this.moreChoose, this.currentParams, 'QABlur')
            console.log(this.subQuestion, 'subQuestionsubQuestion', 'QABlur')
        }
    }
}
</script>

<style lang="less" scoped>
.werwer {
    .van-field {
        border-radius: 8px;
        border: 1px solid #eaeaea;
        .van-field__word-limit {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #b0b2b6;
        }
    }
}
</style>
